(function () {
  if (window.__vpCartUpsellBound) return;
  window.__vpCartUpsellBound = true;

  function money(cents) {
    return 'S/. ' + (Number(cents) / 100).toFixed(2);
  }

  function getImageUrl(product) {
    var img = product.featured_image;
    if (!img && product.media && product.media.length) {
      img = (product.media[0].preview_image && product.media[0].preview_image.src) || product.media[0].src;
    }
    if (!img && product.images && product.images.length) {
      img = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }
    if (!img) return '';
    if (typeof img !== 'string') img = img.src || img.url || '';
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    if (img.indexOf('cdn.shopify.com') !== -1 && img.indexOf('width=') === -1) {
      img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=176';
    }
    return img;
  }

  function buildCard(product) {
    var variant = (product.variants || []).find(function (v) { return v.available; }) || (product.variants || [])[0];
    if (!variant) return '';

    var imgUrl = getImageUrl(product);
    var imgHtml = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy" width="72" height="72">' : '';
    var disabled = variant.available ? '' : ' disabled';

    return (
      '<div class="vp-cart-upsell__item" data-product-id="' + product.id + '">' +
        '<div class="vp-upsell-card">' +
          '<a href="/products/' + product.handle + '" class="vp-upsell-card__media">' + imgHtml + '</a>' +
          '<div class="vp-upsell-card__body">' +
            '<a href="/products/' + product.handle + '" class="vp-upsell-card__title">' + product.title + '</a>' +
            '<div class="vp-upsell-card__price">' + money(variant.price) + '</div>' +
            '<button type="button" class="button button--secondary button--small vp-upsell-add" data-variant-id="' + variant.id + '"' + disabled + '>Añadir al carrito</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function addVariant(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.disabled = true;

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (item) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            button: btn,
            variant: item,
            quantity: 1,
            productAdded: true
          }
        }));
      })
      .catch(function () {})
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vp-upsell-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addVariant(btn.getAttribute('data-variant-id'), btn);
  });

  function enhance(root) {
    if (!root || root.dataset.enhanced === '1') return;

    var track = root.querySelector('[data-vp-upsell-track]');
    if (!track) return;

    var limit = parseInt(root.dataset.limit || '4', 10);
    var cartIds = (root.dataset.cartIds || '').split(',').filter(Boolean);
    var productIds = (root.dataset.productIds || '').split(',').filter(Boolean);
    var cartTags = (root.dataset.tags || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    var cartVendors = (root.dataset.vendors || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    var cartTypes = (root.dataset.types || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    var cartSet = {};
    cartIds.forEach(function (id) { cartSet[id] = true; });
    if (!productIds.length) return;

    root.classList.add('vp-cart-upsell--loading');

    Promise.all(productIds.map(function (pid, index) {
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          return (data.products || []).map(function (product, pos) {
            if (cartSet[String(product.id)]) return null;
            var score = (8 - pos) + (productIds.length - index);
            (product.tags || []).forEach(function (tag) {
              if (cartTags.indexOf(String(tag).toLowerCase()) !== -1) score += 3;
            });
            if (product.vendor && cartVendors.indexOf(String(product.vendor).toLowerCase()) !== -1) score += 2;
            if (product.type && cartTypes.indexOf(String(product.type).toLowerCase()) !== -1) score += 2;
            return { product: product, score: score };
          }).filter(Boolean);
        })
        .catch(function () { return []; });
    }))
      .then(function (lists) {
        var ranked = {};
        lists.forEach(function (items) {
          items.forEach(function (entry) {
            var id = entry.product.id;
            if (!ranked[id] || entry.score > ranked[id].score) ranked[id] = entry;
          });
        });

        var apiList = Object.keys(ranked).map(function (id) { return ranked[id]; })
          .sort(function (a, b) { return b.score - a.score; })
          .slice(0, limit);

        if (!apiList.length) return;

        var existing = {};
        track.querySelectorAll('[data-product-id]').forEach(function (el) {
          existing[el.getAttribute('data-product-id')] = el;
        });

        var merged = [];
        apiList.forEach(function (entry) {
          merged.push({ id: String(entry.product.id), score: entry.score, product: entry.product, source: 'api' });
        });
        Object.keys(existing).forEach(function (id) {
          merged.push({ id: id, score: parseInt(existing[id].getAttribute('data-vp-score') || '0', 10), el: existing[id], source: 'liquid' });
        });
        merged.sort(function (a, b) { return b.score - a.score; });

        var chosen = [];
        var used = {};
        merged.forEach(function (entry) {
          if (chosen.length >= limit || used[entry.id]) return;
          used[entry.id] = true;
          chosen.push(entry);
        });

        track.innerHTML = '';
        chosen.forEach(function (entry) {
          if (entry.source === 'liquid' && entry.el) track.appendChild(entry.el);
          else if (entry.product) track.insertAdjacentHTML('beforeend', buildCard(entry.product));
        });

        requestAnimationFrame(function () { track.scrollLeft = 0; });
        root.dataset.enhanced = '1';
      })
      .finally(function () {
        root.classList.remove('vp-cart-upsell--loading');
      });
  }

  function scan() {
    document.querySelectorAll('[data-vp-upsell]').forEach(function (root) {
      root.dataset.enhanced = '';
      enhance(root);
    });
  }

  function recalcMiniCartHeight() {
    window.dispatchEvent(new Event('resize'));
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('cart:refresh', function () {
    setTimeout(function () {
      scan();
      recalcMiniCartHeight();
    }, 120);
  });
  document.addEventListener('cart:rerendered', function () {
    setTimeout(recalcMiniCartHeight, 60);
  });
})();
